import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
import { toUnionType } from "../../Common/UnionType";
/**
 * moaui Styled Chip
 *
 * @param props - severity, bgColor, color, size, label, disabled
 * @example
 * <Chip
 * 	id=''
 * 	severity="success" || "error" || "warning" || "info"
 * 	bgColor=""
 * 	color=""
 * 	size="small" || "medium"
 * 	label="chip"
 * 	disabled={false || true}
 * />
 * @returns React.ReactElement
 */
function Chip(props) {
    return _jsx(StyledComponent, __assign({}, props));
}
Chip.defaultProps = {
    title: '',
};
var SampleProps = {
    id: '',
    severity: toUnionType({ values: ["success", "error", "warning", "info"] }),
    bgColor: "",
    color: "",
    size: toUnionType({ values: ["small", "medium"] }),
    label: "chip",
    disabled: false,
};
export default Chip;
export { SampleProps as ChipSample, };
